import React from 'react';
import { Link } from 'react-router-dom';

function ActionTile({ to, title, subtitle, icon }) {
  return (
    <Link
      to={to}
      className="group block rounded-2xl border border-slate-800 bg-slate-900/70 p-4 shadow-lg shadow-slate-950/40 transition hover:border-emerald-400 hover:bg-slate-900"
    >
      <div className="flex items-center gap-3">
        <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-600/15 text-emerald-300">
          {icon}
        </div>
        <div className="flex flex-col">
          <span className="text-lg font-semibold text-white">{title}</span>
          <span className="text-sm text-slate-400">{subtitle}</span>
        </div>
      </div>
      <div className="mt-3 text-sm font-semibold text-emerald-300 opacity-0 transition group-hover:opacity-100">
        Open
      </div>
    </Link>
  );
}

function IconClipboard() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-6 w-6">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
      <line x1="9" y1="5" x2="9" y2="7" />
      <line x1="7" y1="9" x2="15" y2="9" />
    </svg>
  );
}

function IconCart() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-6 w-6">
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
  );
}

function IconSearch() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-6 w-6">
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

function IconMore() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-6 w-6">
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
      <circle cx="5" cy="12" r="1" />
    </svg>
  );
}

export default function LiteHome() {
  return (
    <div className="space-y-6">
      <section className="rounded-2xl border border-slate-800 bg-slate-900/80 p-4 text-white shadow-lg shadow-slate-950/50">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs uppercase tracking-[0.24em] text-emerald-300">Ofoodi POS</p>
            <h1 className="mt-1 text-2xl font-semibold">POS Lite</h1>
            <p className="mt-1 text-sm text-slate-300">
              A mobile-first shell for fast pre-orders, quick sales, and product lookup.
            </p>
          </div>
          <span className="rounded-full border border-emerald-500/50 bg-emerald-600/15 px-3 py-1 text-xs font-semibold text-emerald-200">
            Beta
          </span>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-3 text-xs text-slate-400">
          <div className="rounded-xl border border-slate-800 bg-slate-950/60 p-3">
            <p className="text-xs font-semibold text-emerald-200">One-handed</p>
            <p className="mt-1 leading-relaxed">Large tap targets and stacked cards for small screens.</p>
          </div>
          <div className="rounded-xl border border-slate-800 bg-slate-950/60 p-3">
            <p className="text-xs font-semibold text-emerald-200">PWA ready</p>
            <p className="mt-1 leading-relaxed">Install to home screen when the manifest and service worker land.</p>
          </div>
        </div>
      </section>

      <section className="space-y-3">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-white">Shortcuts</h2>
          <span className="text-xs font-semibold uppercase tracking-wide text-emerald-300">Mobile first</span>
        </div>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <ActionTile
            to="/lite/preorders"
            title="Pre-ord"
            subtitle="Cards with status, totals, and actions"
            icon={<IconClipboard />}
          />
          <ActionTile
            to="/lite/sales"
            title="New Sale (Lite)"
            subtitle="Search, add to cart, quick checkout"
            icon={<IconCart />}
          />
          <ActionTile
            to="/lite/products"
            title="Product Lookup"
            subtitle="Search price and stock fast"
            icon={<IconSearch />}
          />
          <ActionTile
            to="/lite/more"
            title="More"
            subtitle="Settings, help, and desktop links"
            icon={<IconMore />}
          />
        </div>
      </section>

      <section className="rounded-2xl border border-slate-800 bg-slate-900/80 p-4 text-sm text-slate-300 shadow-inner shadow-black/40">
        <h3 className="text-base font-semibold text-white">What to expect</h3>
        <ul className="mt-2 space-y-2 list-disc pl-5">
          <li>Pre-orders: single-column cards with quick actions (send invoice/receipt/pickup).</li>
          <li>Sales Lite: thumb-friendly search, add-to-cart, and checkout flow.</li>
          <li>No desktop regressions: full POS stays at <span className="font-semibold text-white">/</span>.</li>
        </ul>
      </section>
    </div>
  );
}
